import React, { useState } from 'react';
import InputForm from '../../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SearchInput from '../../../../SearchInput';
import CheckBox from '../../../../CheckBox';
import SearchModal from '../../../../SearchModal';
import RadioBox from '../../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../../Data/Data.json"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import Spin from 'antd/es/spin';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../../TableResizable';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import formatDate from '../../../../../Functions/Traitement/fomatDate';


//Initialisation des parametres de recherche
//
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeAmort: Params = { CodeAgence: '', Table: "v_typeAmortissement_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeCalcul: Params = { CodeAgence: '', Table: "v_typeCalcul_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypePret: Params = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}

function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  return (
    <div className='tabItemAuto'>
      <div >
        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            {/* <SearchModal   width={7} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
            <InputForm   disabled  width={7} label='Numéro Demande' name='NumeroDemande' type={'text'} />
            <SearchModal  disabled width={7} form={props.form} Titre="Recherche Indice client" label='Indice client' name='Numcli' Parametre={searchIndice} />
            <SearchModal  disabled notRequired width={7} form={props.form} Titre="Recherche Type de financement" label='Type de financement' name='CodeQard' Parametre={searchTypePret} />
            <SearchModal  notRequired  disabled width={7} form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CODGEA' Parametre={searchGes} />
            <InputForm  disabled notRequired  width={7} label='Date Demande' icon={<SwipeUp color='disabled' fontSize='small' />} name='DateDemande' type='date' error='mobile' />
            <SearchModal disabled  width={7} form={props.form} Titre="Recherche Périodicité" label='Périodicité' name='Periodicite' Parametre={searchPeriod} />
            <InputForm  disabled notRequired width={7} label='Dte 1ère Ech' icon={<MonetizationOnOutlined fontSize='small' />} name='DatePremEch' type='date' error='mobile' />
           
          </Grid>

         
            {/* 
            <InputForm notRequired width={7} label='Taux Intéret' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXINT' type='number' error='mobile' />
            <InputForm notRequired width={7} label='Taux Taxe' icon={<MonetizationOnOutlined fontSize='small' />} name='TAUXTAX' type='number' error='mobile' /> */}
            {/* <InputForm notRequired width={7} label='Nbre Pde diféré' icon={<MonetizationOnOutlined fontSize='small' />} name='NBPERDIF' type='number' error='mobile' /> */}
            {/* <SearchModal width={7} form={props.form} Titre='Recherche Type Calcul' label='Type Calcul' name='TYPCALC' Parametre={searchTypeCalcul} /> */}
        
            <Grid item xs={12} md={6} lg={6} className='border-left'>
           
            <legend>Détail Décaissement</legend>
            <InputForm money  disabled notRequired width={7} label='Nombre Decaissement' name='NbDec' type='text' error='mobile' />
            <InputForm money disabled notRequired width={7} label='Montant Validé' icon={<MonetizationOnOutlined fontSize='small' />} name='MontantValide' type='text' error='mobile' />
            <InputForm money notRequired disabled width={7} label='Montant Décaissé' icon={<MonetizationOnOutlined fontSize='small' />} name='TotalDecaisse' type='text' error='mobile' />
            <InputForm money notRequired disabled width={7} label='Montant restant' icon={<MonetizationOnOutlined fontSize='small' />} name='ResteADecaisser' type='text' error='mobile' />
            <InputForm  money disabled={false} width={7} label='Montant à décaisser' icon={<MonetizationOnOutlined fontSize='small' />} name='MontantADecaisser' type='number' error='mobile' 
            dependencies={['ResteADecaisser']} // Relance la validation si le reste à décaisser change
            rules={[
              ({ getFieldValue }: any) => ({
                validator(_: any, value: any) {
                  // Récupération de la valeur du champ "ResteADecaisser"
                  const resteADecaisser = getFieldValue('ResteADecaisser') || 0;
                  
                  // Si aucun montant n'est saisi ou s'il est inférieur ou égal, tout est correct
                  if (!value || value <= resteADecaisser) {
                    return Promise.resolve();
                  }
                  
                  // Sinon, on bloque la validation avec un message clair
                  return Promise.reject(new Error(`Le montant à décaisser ne peut pas dépasser le reste à décaisser (${resteADecaisser})`));
                },
              }),
            ]}
            />
            <InputForm row={1} disabled={false} width={7} label='Raison' icon={<MonetizationOnOutlined fontSize='small' />} name='RaisonDecaisse' type='TextArea' error='mobile' />
        
          </Grid>
        </Grid>
      </div>
    </div>

  )
}
export default Tab1;

